import api from "./api";

export default {
  mixins: [ api ],
  methods: {
    // Статистика по менеджерам
    async getManagerStatistics(data) {
      let params = this.makeSearchParams(data);

      if (data.start_date) {
        const serverDate = this.getDateToServer(data.start_date).toISOString();
        params.set("start", serverDate);
      }

      if (data.end_date) {
        const serverDate = this.getDateToServer(data.end_date).toISOString();
        params.set("end", serverDate);
      }

      if (data.user_id) {
        params.set("user_id", data.user_id);
      }

      return await this.get(`statistics/tasks?${params.toString()}`);
    },
    // Статистика по заказчикам
    async getCustomerStatistics(data) {
      let params = this.makeSearchParams(data);

      if (data.start_date) {
        const serverDate = this.getDateToServer(data.start_date).toISOString();
        params.set("start_date", serverDate);
      }

      if (data.end_date) {
        const serverDate = this.getDateToServer(data.end_date).toISOString();
        params.set("end_date", serverDate);
      }

      if (data.customer_id > 0) {
        params.set("customer_id", data.customer_id);
      }

      if (data.location_id > 0) {
        params.set("location_id", data.location_id);
      }

      return await this.get(`statistics/customers?${params.toString()}`);
    },
  }
}



// WEBPACK FOOTER //
// ./src/network/statistics.js